(function (aimi_campaign, $, app, undefined) {
  // Private object to hold module internals.
  let __this = {};
  __this.parseDate = mobiscroll.util.datetime.parseDate;
  __this.formatDate = mobiscroll.util.datetime.formatDate;

  /**
   * Stores business profile settings, initially empty and to be populated dynamically.
   */
  __this.campaigns = {};

  /**
   * Cached jQuery selector for the document's body.
   */
  __this.$body = $('body');

  /**
   * Represents a list of business profiles, extending functionality from a generic table list.
   * This class is responsible for rendering business profiles into a specific format within a given container.
   * It handles dynamic data loading, parsing, and presentation of business profiles with custom logic for processing and displaying graphical elements such as logos and headshots.
   *
   * @extends TableList
   */
  class CampaignList extends TableList {
    /**
     * Constructs an instance of the CampaignList class.
     */
    constructor(app, container, listRow, searchInputId = 'searchTable') {
      super(app, container, listRow, searchInputId)
    }

    prepareRow(row) {
      const page = _.template(this.app.templates[this.listRow]);
      let config = JSON.parse(row.config), autoBuildDayRange, autoBuildDayStart, autoBuildDayEnd;

      if (parseInt(row.autobuild)) {
        autoBuildDayStart = moment('2022-01-' + config.startDate, 'YYYY-MM-DD');
        autoBuildDayEnd = moment('2022-01-' + config.endDate, 'YYYY-MM-DD');
        autoBuildDayRange = autoBuildDayStart.format('Do') + ' to ' + autoBuildDayEnd.format('Do');
      } else {
        if (!app.isEmpty(config.startDate)) {
          autoBuildDayStart = moment(config.startDate, "MM/DD/YYYY");
          autoBuildDayEnd = moment(config.endDate, "MM/DD/YYYY");
          autoBuildDayRange = autoBuildDayStart.format('Do MMM YYYY') + ' to ' + autoBuildDayEnd.format('Do MMM YYYY');
        }
      }

      let rowExtend = {
        'date_created': __this.formatDate('mm/dd/yy', __this.parseDate('yy-mm-dd H:i:s', row.date_created)),
        'autoBuildDayRange': autoBuildDayRange
      };

      if (row.status === 'completed') {
        rowExtend.autoBuild = (config.frequency.autoBuild) ? 'Auto-build' : 'Built';
      } else {
        rowExtend.autoBuild = 'Incomplete';
      }

      let pageData = {
        ...row,
        ...rowExtend,
      };

      const $page = $(page(pageData));

      return $page;
    }

    removeCalendarLoader(calendar) {
      this.container.find(`.pre-loader[data-calendar="${calendar.id}"]`).remove();
    }

    async fetchCalendarCampaigns(calendar) {
      const self = this;
      const $listContainer = this.container;
      const calendarId = calendar.id;
      const response = await this.app.apis['campaign'].list(calendarId);
      response.calendar = calendar;

      const $loaderArea = this.container.find(`.pre-loader[data-calendar="${calendar.id}"]`).eq(0);
      const $calendarFilter = $('select[name=calendar]');
      const filterId = $calendarFilter.val();

      _.each(response.result, (row) => {
        row.calendar = calendar;
        __this.campaigns[row.id] = row;
        let $row = self.prepareRow(row);
        if(!app.isEmpty(filterId)) {
          if(filterId !== calendar.id) {
            $row.addClass('d-none');
          }
        }
        $row.insertAfter($loaderArea);
      });

      app.localStorage.setItem('campaigns', JSON.stringify(__this.campaigns));
      this.removeCalendarLoader(calendar);

      return response;
    }

    async renderList(calendarIds) {
      const $listContainer = this.container;

      $listContainer.empty();

      for (const calendar of calendarIds) {
        this.showLoader({
          id: null,
          name: this.staticPH,
          autoBuild: '',
          autoBuildDayRange: '',
          calendar: calendar,
          date_created: this.staticPH
        });
      }

      let results = [];
      for (const calendar of calendarIds) {
        const calendarData = await this.fetchCalendarCampaigns(calendar)
        results = results.concat(calendarData);
      }

      this.removeLoader();

      return results;
    }
  }

  /**
   * List
   */
  aimi_campaign.list = {
    listRow: 'campaign__list-row',

    init: function (calendars) {

      const $listContainer = $('[data-campaigns]');
      const $calendarFilter = $('select[name=calendar]');

      if (calendars.length > 1) {
        $calendarFilter.off('change').on('change', function () {
          const $this = $(this);
          const id = $this.val();
          const $tr = $('.campaign-row');
          $tr.removeClass('d-none');

          if (!app.isEmpty(id)) {
            $tr.each(function () {
              let calendarId = $(this).data('calendar');
              if (parseInt(calendarId) === parseInt(id)) {
                console.log(id);
                $(this).removeClass('d-none');
              } else {
                $(this).addClass('d-none');
              }
            });
          }
        });

        $calendarFilter.select2({
          allowClear: true,
          placeholder: 'Search by calendar',
          dropdownCssClass: 'calendar-select2-dropdown',
          selectionCssClass: 'calendar-select2-selection',
          theme: 'bootstrap-5'
        });

        for (const calendar of calendars) {
          const filterOption = $(`<option></option>`);
          filterOption.attr('value', calendar.id);
          filterOption.text(calendar.name);
          filterOption.appendTo($calendarFilter);
          $calendarFilter.trigger('change');
        }


      } else {
        $calendarFilter.closest('.calendar-filter-container').remove();
      }

      __this.listMananger = new CampaignList(app, $listContainer, this.listRow, 'searchTable');

      __this.listMananger.renderList(calendars);

      __this.observerManager = new ImageObserverManager(app, $('.row-image-wrapper', $listContainer).eq(0), 'calendar-card-width');

      // To observe resizing for an element
      __this.observerManager.observeResize($listContainer[0]);

      /**
       * Adjusts card width after waiting for body animations to complete.
       */
      setTimeout(function () {
        __this.observerManager.setCardWidth();
      }, 500);

      /**
       * Handles click events on the delete button of each campaign list item.
       * Confirms the delete action with the user before proceeding.
       */
      $(document).off('click.aimi_campaign_list_delete').on('click.aimi_campaign_list_delete', 'tr:not(.pre-loader) .btn-delete', function (e) {
        let id = $(this).data('id');
        app.confirm("Delete Campaign?", "Are you sure you want to delete this Campaign?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            app.apis['campaign'].delete(id).done(function (response) {
              if (response.success !== true) {

              } else {
                // Render list if deleted
                __this.listMananger.renderList(calendars);
              }
              app.doButtonReset($button);
              app.hideModal($modal);
            }).fail(function (response) {
              app.doButtonReset($button, false);
              app.hideModal($modal);
            });
          }
        });
      });

      new SimpleBar(document.getElementById('tab_block_1'), {autoHide: true});
    }
  }
}(window.aimi_campaign = window.aimi_campaign || {}, jQuery, PreBuilt));